import { render } from "./HistoriaSection.vue?vue&type=template&id=eee90320"
import script from "./HistoriaSection.vue?vue&type=script&lang=js"
export * from "./HistoriaSection.vue?vue&type=script&lang=js"

import exportComponent from "/home/kira/codemark/zonadigital/frond/deploy/zona-digital-ecommerce-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__